import { View } from '../../../../components/discover/aivy-pdf-reports/compiler'
import CoordinateSystem from '../../../../components/discover/aivy-pdf-reports/components/graphs/CoordinateSystem'
import AtAGlance from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/AtAGlance'
import OurReview from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/OurReview'
import { colors } from '../../../../components/discover/aivy-pdf-reports/constants'
import { useTranslationContext } from '../../../../components/discover/aivy-pdf-reports/context/general-translations'

export default function CultureDetailsMessage({
  cultureCategory,
  overall_insights,
  score_visible,
  our_review_title,
  cultural_fit,
  userCultureScores,
  language
}) {
  const { tGeneral } = useTranslationContext()
  return (
    <div>
      <View>
        <AtAGlance
          title={cultureCategory.name[language]}
          description={tGeneral('culture_description')}
          score={overall_insights.insights.culture.group_match}
          score_visible={score_visible}
        />
      </View>
      <View style={{ marginTop: 16 }}>
        <OurReview
          title={our_review_title}
          description={`${overall_insights.insights.culture.category_fit} ${overall_insights.insights.culture.evaluation_level}`}
          score={overall_insights.insights.culture.group_match}
        />
      </View>
      <View style={{ marginTop: 16 }}>
        <View
          style={{
            borderWidth: 1,
            borderColor: colors.lightGrey,
            borderRadius: 8
          }}
        >
          <CoordinateSystem
            companyCultureScores={cultural_fit.cultural_fit_scores}
            userCultureScores={userCultureScores}
          />
        </View>
      </View>
    </div>
  )
}
